import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import '../Css/Map.css';
import { setMapPop } from '../store/api/Modals';
import { Modal } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import Map from '../pages/Map.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalMap = (props) => {
    const dispatch = useDispatch();
    const pop = useSelector(state => state.popup.mapPop);
    const { location } = props;
    const { show } = pop;

    const close = () => {
        dispatch(setMapPop({ show: false }));
    }
    return (
        <Modal show={show} className="superwide-dialog" style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faMapMarkerAlt} size='lg' />&nbsp;
                    انتخاب از نقشه
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} /></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <Map location={{ lat: location.lat, lng: location.lng, zoom: location.zoom }} />
            </Modal.Body>
        </Modal>
    );
};

export default ModalMap;
